<template>
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="form">
      <div class="common-form">激活码弹出框及填写表单</div>
      
      <div v-for="(item, index) in list" :key="index">    
        <!-- <el-divider content-position="left"><span class="blue">{{ item.name }}</span></el-divider>   -->
        <!-- <el-form-item label="填写表单">
          <el-radio-group v-model="form.code_is_form[item.value]">
            <el-radio :label="1">需要填写</el-radio>
            <el-radio :label="0">不需要</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="`【${item.name}】提醒文案`">
          <el-input v-model="form.code_intro[item.value]" type="textarea" rows="5" class="max-w460"></el-input>
        </el-form-item>
      </div>
      
      <!--提交-->
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script>
  import SettingApi from '@/api/study/setting.js';
  import {str2bool} from "@/utils/base.js";
  export default {
    data() {
      return {
        form: {
          is_open: false,
          code_is_form: [],
          code_intro: [],
        },
        loading: false,
        tagVisible: false,
        tagValue: '',
        list: [
          {value: 10, name:'刷题'},
          {value: 20, name:'背诵'},
          {value: 60, name:'模拟考试'},
          {value: 70, name:'专项练习'},
          {value: 81, name:'考研择校'},
          {value: 82, name:'视频解析'},
          {value: 83, name:'精品课程'},
          ]
      };
    },
    created() {
      this.getData();  
      console.log(this.list);
    },
    methods: {
      /*获取数据*/
      getData() {
      let self = this;
      SettingApi.getSetting({}, true)
          .then(res => {
          self.form = res.data.data.basic.values;
          if (!self.form.code_is_form){
            self.form.code_is_form = [];
          }
          if (!self.form.code_intro){
            self.form.code_intro = [];
          }
          self.loading=false;

          self.$forceUpdate();
          self.is_load = true;
          })
          .catch(error => {});
      },

      /*标签*/
      tagClose(tag) {
        this.form.tags.splice(this.form.tags.indexOf(tag), 1);
      },

      tagInput() {
        this.tagVisible = true;
        this.$nextTick(_ => {
          this.$refs.tagInput.$refs.input.focus();
        });
      },

      tagInputConfirm() {
        let value = this.tagValue;
        if (value) {
          this.form.tags.push(value);
        }
        this.tagVisible = false;
        this.tagValue = '';
      },

      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.basic(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
          })
          .catch(error => {
            self.loading = false;
          });
      },

    }
  };
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/study/code/setting/Index.vue